import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import {
  AlertTabContentWrapper,
  AlertTabMessage,
} from "../Cfc/CfcAlert.styles";
import { missingRequisitions } from "../../recoil/atoms";
import { MissingRequisitionResponse } from "../../recoil/types";
import { REQUISITION_URL } from "../../utils/urlConstants";
import {
  HeaderCell,
  MissingInfoRow,
  MissingInfoTable,
  PatientCell,
  StatusBadge,
  StatusBadges,
} from "./ActionsNeededAlertTabContent.styles";

const TAB_DEFINITIONS: Array<{
  label: string;
  hash: string;
  matches: (req: MissingRequisitionResponse) => boolean;
}> = [
  {
    label: "Missing Treatment Notes",
    hash: "#req-treatment-notes",
    matches: (req) => Boolean(req.is_missing_treatment_notes),
  },
  {
    label: "Missing Billing Info",
    hash: "#req-billing-information",
    matches: (req) => Boolean(req.is_missing_billing_info),
  },
  {
    label: "Missing Due Date",
    hash: "#req-general-information",
    matches: (req) => Boolean(req.is_missing_due_date),
  },
];

const getMissingTabs = (req: MissingRequisitionResponse) =>
  TAB_DEFINITIONS.filter(({ matches }) => matches(req));

interface ActionsNeededAlertTabContentProps {
  onRowClick?: () => void;
}

export const ActionsNeededAlertTabContent: FC<
  ActionsNeededAlertTabContentProps
> = ({ onRowClick }) => {
  const history = useHistory();
  const allMissingRequisitions = useRecoilValue(missingRequisitions);

  const rows = (
    Array.isArray(allMissingRequisitions) ? allMissingRequisitions : []
  )
    .map((req) => ({ req, tabs: getMissingTabs(req) }))
    .filter(({ tabs }) => tabs.length > 0);

  return (
    <AlertTabContentWrapper>
      <AlertTabMessage>
        Please provide required information to complete the order:
      </AlertTabMessage>
      <MissingInfoTable>
        <MissingInfoRow $header>
          <HeaderCell>Requisition Name</HeaderCell>
          <HeaderCell>Type</HeaderCell>
        </MissingInfoRow>
        {rows.map(({ req, tabs }) => (
          <MissingInfoRow
            key={req.sfid}
            onClick={() => {
              onRowClick?.();
              history.push(`${REQUISITION_URL}/${req.sfid}/${tabs[0].hash}`);
            }}
          >
            <PatientCell>{req.full_name}</PatientCell>
            <StatusBadges>
              {tabs.map(({ label }) => (
                <StatusBadge key={label}>{label}</StatusBadge>
              ))}
            </StatusBadges>
          </MissingInfoRow>
        ))}
      </MissingInfoTable>
    </AlertTabContentWrapper>
  );
};
